import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {Icon} from "../components/Icon";
import {ColorTheme, IconContainerProps} from "../types";

// This icon is intended for use in AT text.
// But as there are no other brand designs, it is not brand-specific.

export const PlusThinIcon = ({
  colorTheme,
  ...props
}: IconContainerProps): JSX.Element => {
  const theme = useTheme();
  const colortheme: ColorTheme = colorTheme || ColorTheme.dark;
  const isLight = colortheme === ColorTheme.light;

  const GapSVG = (
    <svg viewBox="0 0 11.59 11.59" xmlns="http://www.w3.org/2000/svg">
      <g fill={isLight ? theme.color.wh : theme.color.b1}>
        <path d="M5.27 0h1.25v11.59H5.27z" />
        <path d="M11.6 5.27v1.25H0V5.27z" />
      </g>
    </svg>
  );

  const AthletaSVG = (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 0h2v20H9z" fill={isLight ? theme.color.wh : theme.color.bk} />
      <path d="M20 9v2H0V9z" fill={isLight ? theme.color.wh : theme.color.bk} />
    </svg>
  );

  const brandIconSVGs = {
    [Brands.Athleta]: AthletaSVG,
    [Brands.BananaRepublic]: null,
    [Brands.BananaRepublicFactoryStore]: null,
    [Brands.Gap]: GapSVG,
    [Brands.GapFactoryStore]: GapSVG,
    [Brands.OldNavy]: null,
    crossBrand: null,
  };
  return <Icon {...props} brandIconSVGs={brandIconSVGs} />;
};
